import { IJwtPayload } from "./commonClasses";

declare var angular: any;

interface ILang {
    code: string;
    descriptionKey: string;
}

module GlobalApplicationData {
    const SUPPORTED_LANGS: Array<string> = ["it", "en", "de"];

    angular.module("AdeMesApp").factory("GlobalApplicationData", [() => {
        let GlobalApplicationData = {
            
            //Base service url
            //baseServicesUrl: "https://server/adesuite",
            baseServicesUrl: "https://test.adesuite.com/mda",
            
            //Contesto applicativo
            //applicationContext:"https://server/adesuite/rest/service/ademes/",
            applicationContext:"https://test.adesuite.com/mda/rest/service/ademes/",
            
            // Indica la pagina originariamente richiesta dall'utente che ha scatenato l'autenticazione
            orginalRequestedURL: <string>null,

            // Variabile che contiene il token di autenticazione
            identityToken: <string>null,

            // Informazioni aggiuntive legate al token di autenticazione
            jwtPayload: <IJwtPayload>null,

            // Definisco l'array che conterrà tutte le possibili azioni a cui un utente è abilitato
            auths: <Array<string>>[],

            // Definisco l'array per le lingue disponibili nell'applicazione che sarà popolato da authenticatingCtrl
            // L'attributo mandatory indica che è obbilgatoria e di default (infatti deve sempre essercene solo una di mandatory)
            langs: <Array<ILang>>[],
            
            //Token di default
            token: "eyJjcmVhdGVkIjoxNTU5MTE1MjY4NzY5LCJhbGciOiJIUzUxMiJ9.eyJ1c2VySWQiOiIxMDAwOTAwIiwidXNlcm5hbWUiOiJNZGFVc2VyIiwiYXV0aG9yaXphdGlvbnMiOltdfQ.8NHmJcZWGqDTgs7kzPALkRa47brzwlxvsrDlubBgj7qxu4tErxko1OXsE0-yBMXMrAuSesAjU8Fb0VuDWaBq3w",
            
            //Client di default
            ad_client_id: "1000060",
            
             //Url di default
            default_state: "calendar",
            
            //Visualizzare ore lavorate e ultimo rapportino: true, per non visualizzarle mettere a false
            headerDetail: true, 

            //Visualizzare bottone per accedere ai documenti
            documentButton: true,

            //Visualizzare bottone per la lista report
            showReportListButton: true
            
        };

        SUPPORTED_LANGS.forEach(lang => {
            GlobalApplicationData.langs.push({
                code: lang,
                descriptionKey: "generic.langs." + lang
            });
        });

        return GlobalApplicationData;
    }])
};